<template>
  <div class="schedule schedule-wrapper">
    <h1 class="title layout-spacing-big">Raspored</h1>
    <section class="main layout-spacing">
      <div class="schedule-menu">
        <div class="schedule-day schedule-day--app">
          <button class="schedule-day-button active" v-on:click="toggleDay(0)">14</button>
          <button class="schedule-day-button" v-on:click="toggleDay(1)">15</button>
          <button v-on:click="showPersonal" class="schedule-day-button my-schedule-button">
            <div class="favorites-icon"></div>
            <span v-if="appliedEvents.length + favoritedEvents.length > 0" class="schedule-number-icon">
              {{ appliedEvents.length + favoritedEvents.length }}
            </span>
          </button>
        </div>
        <div class="schedule-type active0" v-show="!isPersonalScheduleActive">
          <div class="schedule-type__button active" v-on:click="showScheduleContainer(0)">
            Predavanja i paneli
          </div>
          <div class="schedule-type__button" v-on:click="showScheduleContainer(1)" v-if="features.workshops">
            Radionice
          </div>
        </div>
        <div class="schedule-notice">
          <img src="@/assets/icons/info.svg" alt="info" />
          <p>Predavanja i panel rasprave su dostupni samo preko live streama. Radionice su na FESB-u u dvorani A100.</p>
        </div>
      </div>
      <section class="schedule-container">
        <section class="schedule-item-container active" v-if="!isPersonalScheduleActive">
          <template v-if="shownEvents.hasOwnProperty('Lecture') && shownEvents.Lecture.length">
            <template v-for="event in shownEvents.Lecture">
              <ScheduleItem
                v-bind:refreshFavorites="refreshFavorites"
                v-bind:event="event"
                v-bind:key="event.id"
                v-bind:favoritedEvents="favoritedEvents"
              />
            </template>
          </template>
          <p class="in-progress" v-else>Raspored je još u izradi</p>
        </section>

        <section class="schedule-item-container" v-if="!isPersonalScheduleActive">
          <template v-if="shownEvents.hasOwnProperty('Workshop') && shownEvents.Workshop.length">
            <template v-for="event in shownEvents.Workshop">
              <ScheduleItem
                v-bind:refreshFavorites="refreshFavorites"
                v-bind:event="event"
                v-bind:key="event.id"
                v-bind:appliedEvents="appliedEvents"
              />
            </template>
          </template>
          <p class="in-progress" v-else>Raspored je još u izradi</p>
        </section>

        <section class="schedule-item-container" v-if="!isPersonalScheduleActive">
          <template v-if="shownEvents.hasOwnProperty('JigsawSession') && shownEvents.JigsawSession.length">
            <template v-for="event in shownEvents.JigsawSession">
              <ScheduleItem
                v-bind:refreshFavorites="refreshFavorites"
                v-bind:event="event"
                v-bind:key="event.id"
                v-bind:favoritedEvents="favoritedEvents"
              />
            </template>
          </template>
        </section>
      </section>

      <div class="my-schedule__container" v-if="isPersonalScheduleActive">
        <MySchedule
          v-bind:refreshFavorites="refreshFavorites"
          v-bind:appliedEvents="appliedEvents"
          v-bind:favoritedEvents="favoritedEvents"
          v-bind:distinctDays="distinctDays"
          v-bind:activeEventType="currentActiveEventType"
          v-bind:changeActiveEventTypeOnSchedule="showScheduleContainer"
          v-if="(appliedEvents && appliedEvents.length) || (favoritedEvents && favoritedEvents.length)"
        />
        <div class="no-saved" v-else>
          <div>
            Nemaš spremljenih događaja.
          </div>
          <button v-on:click="toggleDay(0)">
            <span>Kreiraj svoj raspored</span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ScheduleItem from '@/components/app/ScheduleItem.vue';
import MySchedule from '@/components/app/MySchedule.vue';

import { groupBy } from '@/config';
export default {
  name: 'Schedule',
  data() {
    return {
      distinctDays: [],
      events: {},
      shownEvents: {},
      hasLoaded: false,
      personalScheduleNumber: 0,
      isPersonalScheduleActive: false,
      appliedEvents: [],
      favoritedEvents: [],
      currentActiveEventType: 0,
      isArrivalTimePickerModalActive: false,
      route: 'app/schedule',
      features: {},
    };
  },
  components: {
    ScheduleItem,
    MySchedule,
  },
  methods: {
    toggleDay: function(dayNumber) {
      this.isPersonalScheduleActive = false;
      let controls = document.querySelectorAll('.schedule-menu button');
      for (let control of controls) control.classList.remove('active');
      controls[dayNumber].classList.add('active');
      this.filterShownEvents(dayNumber);
      setTimeout(() => {
        this.showScheduleContainer(this.currentActiveEventType);
        document.dispatchEvent(new CustomEvent('scroll'));
      });
    },
    filterShownEvents: function(dayNumber) {
      for (let category in this.shownEvents) {
        this.shownEvents[category] = this.events[category].filter(
          event => new Date(event.starts).getDate() === this.distinctDays[dayNumber],
        );
        this.$forceUpdate();
      }
    },
    showScheduleContainer: function(indexOfContainerToShow) {
      this.currentActiveEventType = indexOfContainerToShow;
      let scheduleItemContainers = document.querySelectorAll('.schedule-item-container');
      let scheduleTypeButtons = document.querySelectorAll('.schedule-type__button');
      let scheduleType = document.querySelector('.schedule-type');
      for (let i = 0; i < 3; i++) {
        if (i === indexOfContainerToShow) scheduleType.classList.add(`active${i}`);
        else scheduleType.classList.remove(`active${i}`);
      }
      scheduleTypeButtons.forEach((button, index) => {
        button.classList.remove('active');
        if (index === indexOfContainerToShow) button.classList.add('active');
      });
      for (let container of scheduleItemContainers) container.classList.remove('active');
      scheduleItemContainers[indexOfContainerToShow].classList.add('active');
      document.dispatchEvent(new CustomEvent('scroll'));
    },
    showPersonal: function() {
      this.isPersonalScheduleActive = true;
      let controls = document.querySelectorAll('.schedule-menu button');
      for (let control of controls) control.classList.remove('active');
      let scheduleItemContainers = document.querySelectorAll('.schedule-item-container');
      for (let container of scheduleItemContainers) container.classList.remove('active');
      controls[2].classList.add('active');
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('scroll'));
      });
    },
    refreshFavorites: function() {
      this.$axios.get(`${this.$API_URL}/user/applied-workshops`).then(response => {
        this.appliedEvents = response.data;
        try {
          let parsedEvents = JSON.parse(localStorage.getItem('favoritedEvents2020'));
          this.favoritedEvents = [...parsedEvents];
        } catch (_) {
          this.favoritedEvents = [];
        }
      });
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: this.route } }).then(response => {
      this.features = response.data.features.reduce((acc, x) => {
        acc[x.path.replace(`${this.route}/`, '')] = x.isActive;

        return acc;
      }, {});
    });
  },
  mounted() {
    this.refreshFavorites();
    this.$axios.get(`${this.$API_URL}/events/events-for-schedule`).then(response => {
      this.distinctDays = [...new Set(response.data.map(event => new Date(event.starts).getDate()))].sort();

      if (response && response.data && response.data.length !== 0) {
        this.isScheduleActive = true;
      }

      this.events = groupBy(response.data, 'type');
      this.shownEvents = Object.assign({}, this.events);
      let eventTypeToShow = this.$route.params.shown;
      switch (eventTypeToShow) {
        case 'workshop':
          this.showScheduleContainer(1);
          break;
        case 'jigsawsession':
          this.showScheduleContainer(2);
          break;
        case 'my-schedule':
          setTimeout(() => {
            this.showPersonal();
          });
          break;
        case 'lecture':
        default:
          this.showScheduleContainer(0);
          break;
      }
      this.toggleDay(0);
      this.hasLoaded = true;
    });
  },
};
</script>

<style scoped>
.schedule-wrapper {
  padding: 48px 24px 100px;
}

.title {
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 64px;
}

.schedule-main-menu {
  width: unset;
}

.schedule-day--app {
  display: flex;
  align-items: flex-start;
}

.my-schedule-button .favorites-icon {
  mask: url('../../assets/app-icons/schedule/favorites.svg');
  width: 30px;
  height: 28px;
  mask-size: 30px;
  background-color: #ffffff;
  margin: 0 auto;
  transition: all 0.5s ease-in-out;
  mask-repeat: no-repeat;
}

.my-schedule-button::before {
  display: none;
}

.my-schedule-button.active .favorites-icon,
.my-schedule-button:hover .favorites-icon {
  background-color: #35e5d8;
}

.my-schedule-button::after {
  content: 'favoriti';
  margin-top: 5px;
}

.schedule-main-menu button {
  margin-left: 20px;
}

.my-schedule__container {
  width: 100%;
}

.schedule-number-icon {
  position: absolute;
  display: block;
  width: 32px;
  height: 32px;
  font-size: 16px;
  line-height: 32px;
  font-weight: bold;
  border-radius: 50%;
  bottom: -12px;
  right: -12px;
  color: #fff;
  background-color: #0a181b;
  border: 2px solid #ffffff;
  transition: all 0.5s ease-in-out;
}

.my-schedule-button.active .schedule-number-icon,
.my-schedule-button:hover .schedule-number-icon {
  border: 2px solid #35e5d8;
  color: #35e5d8;
}

.no-after::after {
  display: none;
}
.no-saved {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-content: center;
  justify-content: center;
}

.no-saved div {
  width: 100%;
  text-align: center;
  margin-top: 110px;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: bold;
  font-size: 24px;
}

.no-saved button {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.8);
  border: none;
  font-family: 'Fuse V.2 Display';
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  line-height: 18px;
  padding: 18px 24px;
  border-radius: 15px;
  transition: all 0.5s ease-in-out;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
}

.no-saved button:hover {
  border: 2px solid #30cec2;
  color: white;
}

.text {
  color: white;
}

.text--emphisis {
  text-decoration: underline;
}

.in-progress {
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  margin: auto;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
}

@media screen and (min-width: 1023px) {
  .schedule-wrapper {
    padding: 160px 100px;
  }

  .title {
    margin-bottom: 48px;
  }
}
</style>
